module.exports = __webpack_public_path__ + "img/product-preview-91.26c2dfd.png";